import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { ToastService } from '@core/services/toast.service';
import { Observable, take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { clearStorage } from '@core/i18n/clear-storage';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private auth: AuthService, private router: Router, private toast: ToastService, private translocoService: TranslocoService) { }
  canActivateChild( route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isValid = true;

    this.auth.getActiveSession().pipe(take(1)).subscribe((res) => {
      if (!res) {
        clearStorage();
         this.router.navigate(['/login'], { queryParams: { callbackUrl: state.url } });
      }
    });

    const isUserLoggedIn = this.auth.checkLogin();

    if (!isUserLoggedIn) {
      isValid = false;
      this.logoutCurrentUser();
      this.router.navigateByUrl('login');
      this.toast.error(this.translocoService.translate('shared.messages.unauthorizedAccess'));
    }
    return isValid;
  }

  logoutCurrentUser(): void {
    const loggedInUser = this.auth.getCurrentUser();
    if (loggedInUser) this.auth.logout().pipe(take(1)).subscribe();
  }

}
